import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class CommunicateService {
    hideHeader = new BehaviorSubject(true);
    isLoaderLoad = new BehaviorSubject(false);


    groupBy<T, K extends keyof any>(array: T[], key: (item: T) => K): Record<K, T[]> {
        return array.reduce((result, item) => {
            const groupKey = key(item);
            (result[groupKey] ||= []).push(item);
            return result;
        }, {} as Record<K, T[]>);
    }
}